var _defs, _path, _path2, _rect, _path3, _rect2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 150,
    height: 150,
    className: "mainStroke",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.14,32c0,3.85,2.78,7.05,6.43,7.73v-15.46c-3.66.68-6.43,3.88-6.43,7.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.86,32c0-3.85-2.78-7.05-6.43-7.73v15.46c3.65-.67,6.43-3.88,6.43-7.73Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.6,
    y: 23.89,
    width: 10.04,
    height: 16.22
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m51.17,42.97c-.79,0-1.43-.64-1.43-1.43v-19.08c0-.79.64-1.43,1.43-1.43h11.47v-9.1c0-.79-.64-1.43-1.43-1.43h-27.77v10.88c5.24.7,9.3,5.19,9.3,10.62s-4.06,9.92-9.3,10.62v10.88h27.77c.79,0,1.43-.64,1.43-1.43v-9.1s-11.47,0-11.47,0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.37,
    y: 23.89,
    width: 10.04,
    height: 16.22
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.57,42.62c-5.24-.7-9.3-5.19-9.3-10.62s4.06-9.92,9.3-10.62v-10.88H2.8c-.79,0-1.43.64-1.43,1.43v9.1h11.47c.79,0,1.43.64,1.43,1.43v19.08c0,.79-.64,1.43-1.43,1.43H1.37v9.1c0,.79.64,1.43,1.43,1.43h27.77v-10.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStade);
export default __webpack_public_path__ + "static/media/stade.9179c5470a4e18144cf040082b3dabfc.svg";
export { ForwardRef as ReactComponent };